import { Link } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";

import { ROUTES } from "@/utils/navigation";

//import { Partners, Reviews } from "./components";
import Section from "@/components/Section";

const NextStep = () => {
  return (
    <Section pt={{ xs: 0, md: 8, lg: 12.5 }} pb={{ xs: 10, lg: 12.5 }}>
      <Grid container spacing={{ xs: 3, md: 3, lg: 6, xl: 11 }}>
        <Grid item xs={12} lg={12}>
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <Typography color="text.primary" variant="h2" mb={2}>
              Take Your Fleet to the Next Level With Trackmate
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              mb={{ xs: 4, md: 8, lg: 10 }}
              maxWidth={{ xs: "auto", lg: 580 }}
            >
              Complete the Fleet Inquiry form now to get started. The more information we have the better we can serve you!
            </Typography>

            <Button
              variant="contained"
              component={Link}
              to={`${ROUTES.fleetInquiryForm}`}
              sx={{ width: { xs: "100%", sm: 222 } }}
            >
              Fill out form
            </Button>
          </Box>
        </Grid>

        {/* <Grid item xs={12} lg={6}>
          <Reviews />
          <Partners />
        </Grid> */}
      </Grid>
    </Section>
  );
};

export default NextStep;
